<template>
  <div>
    <Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true">
      <SecondaryButton
        text="閉じる"
        class="ml-auto w-fit block my-1 mr-1"
        @click="closed()"
      >
      </SecondaryButton>
      <template #action>
        <div :class="isMobileDevice?'w-full':'min-w-400px'">
          <div class="font-bold text-indigo-700 text-center">{{ title }}</div>

          <!-- 完了済み -->
          <div v-if="val.complete">
            <div class="font-bold text-green-700 mb-3">完了済み</div>
            <div class="font-bold text-gray-700 mb-2"><span v-if="val.type!=7">物件名：</span>{{ val.siteName }}</div>
            <div class="font-bold text-gray-700 mb-2">実施日：{{ dateTime }}</div>
            <div class="font-bold text-gray-700 mb-2">担当者：{{ val.userName }}</div>
          </div>

          <!-- 未完了 -->
          <div v-else>
            <div class="font-bold text-yellow-700 mb-3">未完了</div>
            <div v-if="val.type == 3" class="font-bold text-red-700 text-sm mb-2">※定期清掃のみ、予定日を変更した際にメインタスクを自動登録します。</div>
            <div class="font-bold text-gray-700 mb-2"><span v-if="val.type!=7">物件名：</span>{{ val.siteName }}</div>

            <!-- 予定日 -->
            <div class="text-xs font-bold text-gray-700 mb-1 mt-5">
              予定日 <span class="-top-0.5 ml-1 text-red-500"> * </span>
            </div>

            <!-- 定期 -->
            <div v-if="val && val.type == 3 && scheduledDate && scheduledDate.length">
              <div v-for="(row, i) in scheduledDate" :key="i" class="flex my-2">
                <div v-if="scheduledDate.length > 1" class="font-bold text-xs mr-5 text-blue-700 self-center">{{ i + 1 }} 日目</div>
                <!-- 完了済み -->
                <div v-if="row.completionDate" class="flex">
                  <div class="text-sm font-bold">（完了済み） {{ row.completionDate }}</div>
                </div>

                <!-- 未完了 -->
                <div v-else class="flex items-end">
                  <!-- 日にち -->
                  <WmsDateInput
                    :name="'scheduledDate'+i"
                    v-model="row.scheduledDate"
                    class="w-28"
                    :min="minDay(i)"
                    @change="changeFlg=true"
                  />

                  <!-- 予定時刻 -->
                  <div class="bg-white border border-blue-700 rounded ml-2">
                    <input type="number"
                      v-model="row.sHour"
                      class="w-10 border-0 rounded px-0.5 py-1 text-center"
                      @wheel.prevent
                      @change="changeFlg=true"
                    >
                    <span class="text-gray-700 font-bold">：</span>
                    <input type="number"
                      v-model="row.sMinu"
                      class="w-10 border-0 rounded px-0.5 py-1 text-center"
                      @wheel.prevent
                      @change="changeFlg=true"
                    >
                  </div>

                  <div class="px-1 text-blue-700 font-bold self-center">～</div>

                  <div class="bg-white border border-blue-700 rounded">
                    <input type="number"
                      v-model="row.eHour"
                      class="w-10 border-0 rounded px-0.5 py-1 text-center items-center"
                      @wheel.prevent
                      @change="changeFlg=true"
                    >
                    <span class="text-gray-700 font-bold">：</span>
                    <input type="number"
                      v-model="row.eMinu"
                      class="w-10 border-0 rounded px-0.5 py-1 text-center"
                      @wheel.prevent
                      @change="changeFlg=true"
                    >
                  </div>

                  <TrashIcon v-if="i" class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-6 h-6 ml-3 self-center" @click="deleteDay(i)"/>
                </div>
              </div>
            </div>

            <!-- 定期以外 -->
            <div v-else>
              <input type="date" v-model="scheduledDate" :min="today" class="rounded border-gray-300 w-full" @change="changeFlg=true" />
            </div>

            <!-- 担当者 -->
            <div class="text-xs font-bold text-gray-700 mt-3 mb-1">
              担当者 <span class="-top-0.5 ml-1 text-red-500"> * </span>
            </div>
            <!-- 同行以外は変更OK -->
            <select
              v-if="val.type != 7"
              v-model="val.userId"
              @change="selectStaff()"
              class="border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500 block w-full text-gray-700"
            >
              <option
                v-for="list in setStaffList" :key='list.id'
                :value="list.userId"
                class="bg-white">
                {{ list.name }}
              </option>
            </select>

            <div v-else class="pl-3">
              {{ val.userName }}
              <div class="text-gray-600 text-xs font-bold mt-2">※同行の担当者はこの画面で編集できません。</div>
            </div>
          </div>

          <PrimaryButton
            :text="loading?'Loading...':'報告書を開く'"
            :disabled="changeFlg||loading"
            class="mt-5 w-full"
            :class="!changeFlg?'':'bg-gray-300'"
            @click="openCheckList()"
          >
          </PrimaryButton>

          <PrimaryButton
            v-if="!val.complete"
            :text="loading?'Loading...':'変更'"
            :disabled="!changeFlg||loading"
            class="mt-5 mb-3 w-full"
            :class="changeFlg?'':'bg-gray-300'"
            @click="save()"
          >
          </PrimaryButton>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>

import Modal from '@components/Modal.vue'
import { TrashIcon } from '@vue-hero-icons/solid'
import * as backend from '@libs/backend'
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'
import * as moment from 'moment'

export default {
  components: {
    Modal,
    TrashIcon,
    PrimaryButton,
    SecondaryButton,
    WmsDateInput,
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    target: {
      type: Object
    },
    staffList: {
      type: Array
    },
    gpsDiff: {
      type: Number
    }
  },

  data() {
    return {
      loading: false,
      // 表示するデータ
      val: {},
      // 予定日
      scheduledDate: null,
      // 本日日付
      today: moment().format('YYYY-MM-DD'),
      // 変更フラグ
      changeFlg: false,
      // 定期清掃の元の日程
      before: null,

    }
  },

  computed: {
    /**
     * スマホ
     */
    isMobileDevice() {
      return utils.deviceInfo.isMobile
    },

    /**
     * タイトル表示
     */
    title() {
      if (this.val.type) {
        let res = ''
        switch (this.val.type) {
          case 1:
            if (this.val.claim) {
              res = '品質巡回（クレーム）'
            } else if (this.val.spot) {
              res = '品質巡回（スポット）'
            } else {
              res = '品質巡回'
            }
            break;

          case 2:
            res = '巡回清掃'
            break;

          case 3:
            res = '定期清掃'
            break;

          case 4:
            res = '設備点検'
            break;

          case 7:
            res = '同行'
            break;
        }
        return res
      }
      return null
    },

    /**
     * 完了日
     */
    dateTime() {
      let res = null
      if (this.val) {
        if (this.val.start) {
          res = moment(this.val.start).format('YYYY/MM/DD HH:mm')
          if (this.val.end) {
            res += ' ~ '
            res += moment(this.val.end).format('YYYY/MM/DD HH:mm')
          }
        }
      }
      return res
    },

    /**
     * スタッフリスト生成
     */
    setStaffList() {
      let res = []
      if (this.val && this.val.type && this.staffList.length) {
        res = this.staffList.filter((s) => {
          return s.type == this.val.type
        })
      }
      return res
    },
  },

  watch: {
    open() {
      if (this.open) {
        this.getData()
      } else {
        return
      }
    },

  },

  async created() {
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      this.scheduledDate = null
      this.before = null
      this.today = moment().format('YYYY-MM-DD')
      if (this.target && Object.keys(this.target).length) {
        this.val = this.target

        // 定期清掃の場合、連日作業があるためデータ取得
        if (this.target.type == 3) {
          this.loading = true
          this.scheduledDate = []
          const res = await backend.searchData('patrolSchedule/getFixedSchedule', { id: this.target.id })
          if (res.data.data) {
            this.scheduledDate = res.data.data
            this.before = utils.clone(res.data.data)

            this.val.complete = !res.data.data.some(r => !r.completionDate)
          } else {
            alert('エラーが発生しました')
            this.closed()
          }
          this.loading = false
        // 定期清掃以外
        } else {
          if (!this.val.complete) {
            this.scheduledDate = moment(this.val.start).format('YYYY-MM-DD')
          }
        }

      } else {
        this.val = {}
      }
    },

    /**
     * スタッフ選択イベント
     */
    selectStaff() {
      const res = this.setStaffList.find((s) => {
        return s.userId == this.val.userId
      })
      if (this.val.type == 1) {
        this.val.patrolNumber = res.patrolNumber
      } else {
        this.val.patrolNumber = null
      }
      this.val.userName = res.name
      this.changeFlg = true
    },

    /**
     * 報告書開く
     */
    async openCheckList() {
      let name = ''
      switch (this.val.type) {
        case 1:
          name = 'CheckListTable'
          break;
        case 2:
          name = 'RoundCheckListTable'
          break;
        case 3:
          name = 'FixedCheckListTable'
          break;
        case 4:
          name = 'FacilityCheckListTable'
          break;
        case 7:
          name = 'PhotoReport'
          break;

        default:
          break;
      }

      // 同行
      if (this.val.type == 7) {
        let row = {}
        row.id = this.val.id

        const res = await backend.searchData('photoReport/getType', { menu: 'accompany' })
        if (res.data.data) {
          let mst = res.data.data[0]
          row = utils.photoReportParam(row, mst)
          row.typeName = mst.typeName
          row.title = this.val.siteName

          this.$router.push({
            name,
            params: {
              target: row
            },
            query: {
              id: row.id,
              routeName: this.$route.name
            }
          })
        }
      // 同行以外
      } else {
        // 未完了の場合、緯度経度取得
        let siteLocation = {}
        if (!this.val.complete) {
          const res = await backend.searchData('patrolSchedule/getPosition', { siteCode: this.val.siteCode })
          if (res.data.data) {
            siteLocation = res.data.data
          }
        }
        // paramにスケジュールIDを渡す
        let scheduleId = this.val.id
        // 予定日
        let scheduledDate = this.val.scDate
        // 連日の〇日目
        let sub = this.val.subNum

        // 定期清掃で連日作業がある場合、1日目から埋めていく
        if (this.val.type == 3 && Array.isArray(this.scheduledDate) && this.scheduledDate.length > 1) {
          for (let i = 0; i < this.scheduledDate.length; i++) {
            const s = this.scheduledDate[i]
            // 未完了に限る
            if (!s.completionDate) {
              scheduledDate = s.scheduledDate
              sub = i
              break
            }
          }
        }
        // 点検表に遷移
        this.$router.push({
          name,
          query: { scheduleId, claim: this.val.claim, sub },
          params: { scheduledDate, siteLocation, spot: this.val.spot }
        })
      }
    },

    /**
     * 変更保存
     */
    async save() {
      const today =  Number(this.today.replace(/-/g, ''))
      let mainTask = false
      let before = []
      let after = []
      // 定期清掃
      if (this.val.type == 3) {

        for (let i = 0; i < this.scheduledDate.length; i++) {
          const s = this.scheduledDate[i]
          if (!s.scheduledDate) {
            await dialogs.showErrorDialog((i + 1) + '日目の予定日', '予定日を入力してください。')
            return
          }

          const scDay = Number(s.scheduledDate.replace(/-/g, ''))

          if (!s.completionDate && scDay < today) {
            await dialogs.showErrorDialog((i + 1) + '日目の予定日が過去日になっています', '予定日は、本日以降にしてください。')
            return
          }

          if (!s.completionDate && i > 0 && scDay <= Number(this.scheduledDate[i-1].scheduledDate.replace(/-/g, ''))) {
            await dialogs.showErrorDialog((i + 1) + '日目の予定日', `${i + 1}日目の予定日が前日以前になっています。前日より未来日に設定してください。`)
            return
          }

          if (!s.completionDate) {
            // 予定時間
            if (!s.sHour || !s.sMinu || !s.eHour || !s.eMinu) {
              await dialogs.showErrorDialog(s.day + 'の予定時刻 未完成', `予定時刻を完成させてください。`)
              return
            }
            if (Number(s.sHour) <= 0 || Number(s.sHour) >= 24 || isNaN(s.sHour)) {
              s.sHour = null
              await dialogs.showErrorDialog(s.day + 'の予定開始時刻', `予定時刻を完成させてください。`)
              return
            }
            if (Number(s.sMinu) < 0 || Number(s.sMinu) >= 60 || isNaN(s.sMinu)) {
              s.sMinu = null
              await dialogs.showErrorDialog(s.day + 'の予定開始時刻', `予定時刻を完成させてください。`)
              return
            }
            if (Number(s.eHour) <= 0 || Number(s.eHour) >= 24 || isNaN(s.eHour)) {
              s.eHour = null
              await dialogs.showErrorDialog(s.day + 'の予定終了時刻', `予定時刻を完成させてください。`)
              return
            }
            if (Number(s.eMinu) < 0 || Number(s.eMinu) >= 60 || isNaN(s.eMinu)) {
              s.eMinu = null
              await dialogs.showErrorDialog(s.day + 'の予定終了時刻', `予定時刻を完成させてください。`)
              return
            }
            s.sh = String(s.sHour).padStart(2, '0')
            s.sm = String(s.sMinu).padStart(2, '0')
            s.eh = String(s.eHour).padStart(2, '0')
            s.em = String(s.eMinu).padStart(2, '0')

            s.scheduledStartTime = s.sh + ':' + s.sm
            s.scheduledEndTime = s.eh + ':' + s.em

            if (s.scheduledStartTime >= s.scheduledEndTime) {
              await dialogs.showErrorDialog('予定時刻 不正', `予定時刻が不正です。開始時刻と終了時刻をご確認ください。`)
              return
            }
          }

        }

        before = this.before.map((b) => {
          return b.scheduledDate + ' （予定時刻 ' + b.scheduledStartTime + '～' + b.scheduledEndTime + '）'
        })
        after = this.scheduledDate.map((b) => {
          return b.scheduledDate + ' （予定時刻 ' + b.scheduledStartTime + '～' + b.scheduledEndTime + '）'
        })

        if (before.join('') != after.join('')) {
          mainTask = true
          const log = await dialogs.showConfirmDialog('変更しますか？', '定期清掃の場合、メインタスクも登録します。\r\n変更してよろしいでしょうか？')
          if (log != 'YES') {
            return
          }
        }
      // 定期清掃以外
      } else {
        if (!this.scheduledDate) {
          await dialogs.showErrorDialog('予定日', '予定日を入力してください。')
          return
        }

        if (Number(this.scheduledDate.replace(/-/g, '')) < today) {
          await dialogs.showErrorDialog('予定日が過去日になっています', '予定日は、本日以降にしてください。')
          return
        }
      }

      if (!this.val.userId && this.val.type != 7) {
        await dialogs.showErrorDialog('担当者', '担当者を選択してください。')
        return
      }

      // 保存するデータを成型
      const saveData = {
        id: this.val.id,
        type: this.val.type,
        scheduledDate: this.scheduledDate,
        userName: this.val.userName,
        userId: this.val.userId,
        patrolNumber: this.val.patrolNumber,
        insertUser: this.$store.getters.user.id,
        insertName: this.$store.getters.user.user_name,
        siteName: this.val.siteName
      }
      this.loading = true
      await backend.postData('patrolSchedule/upDateByCalendarModal', saveData)

      // 定期清掃のみ、予定日が変更されている場合
      if (this.val.type == 3 && mainTask) {
        // メインタスク登録
        let limitDate = this.today
        for (let i = 0; i < this.scheduledDate.length; i++) {
          const s = this.scheduledDate[i]
          if (!s.completionDate) {
            limitDate = s.scheduledDate
            break
          }
        }
        const val = {
          siteName: this.val.siteName,
          before: before.join('\r\n'),
          after: after.join('\r\n'),
          user: this.$store.getters.user,
          userDepartment: this.$store.getters.userDepartment,
          limitDate: moment(limitDate).add(-1, 'days').format('YYYY-MM-DD')
        }

        await utils.mainForChangeFixed(val, this)
        this.loading = false
      }
      this.$emit('getData')
      this.closed()
    },

    /**
     * 定期清掃の予定日制限
     */
    minDay(i) {
      if (this.val && this.val.type == 3) {
        if (!i) {
          return this.today
        }
        const min1 = Number(this.today.replace(/-/g, ''))
        const min2 = Number(this.scheduledDate[i-1].scheduledDate.replace(/-/g, ''))
        if (min1 >= min2) {
          return this.today
        } else {
          return this.scheduledDate[i-1].scheduledDate
        }
      }
    },

    /**
     * 自動で次の入力フォームへ
     */
    // autoNext(e, nextRef) {
    //   const val = e.target.value
    //   // 2桁以上入力したら次の入力フォームへ
    //   if (val && val.length >= 2) {
    //     this.$refs[nextRef][0].focus()
    //   }
    // },

    /**
     * 閉じる
     */
    closed() {
      this.scheduledDate = null
      this.changeFlg = false
      this.$emit('closed')
    },
  }
}
</script>
<style scoped>
.content-container-app {
  width: 100%;
}
</style>